import dayjs from 'dayjs';

import type { OpenMeteoDailyBlock } from '@/features/dashboard/types/openMeteo.types';

export interface DailyForecastUiRow {
  key: string;
  dateLabel: string;
  sortKey: string;
  weatherCode: number;
  tempMin: number | null;
  tempMax: number | null;
  precipitationMm: number | null;
}

export function dailyOpenMeteoToUiRows(daily: OpenMeteoDailyBlock): DailyForecastUiRow[] {
  const { time, weather_code, temperature_2m_max, temperature_2m_min, precipitation_sum } = daily;
  if (!time?.length) return [];
  const wc = weather_code ?? [];
  const tmax = temperature_2m_max ?? [];
  const tmin = temperature_2m_min ?? [];
  const precip = precipitation_sum ?? [];

  return time.map((timeStr, i) => ({
    key: `${timeStr}-${i}`,
    dateLabel: dayjs(timeStr).format('DD/MM'),
    sortKey: dayjs(timeStr).format('YYYY-MM-DD'),
    weatherCode: wc[i] ?? 0,
    tempMax: tmax[i] ?? null,
    tempMin: tmin[i] ?? null,
    precipitationMm: precip[i] ?? null,
  }));
}
